// API Configuration
// These values will be replaced by environment variables in production

const config = {
  // Backend API URL
  // Local: http://localhost:5000/api
  // Production: Your Render backend URL (e.g., https://doclinic-backend.onrender.com/api)
  API_URL: process.env.REACT_APP_API_URL || 'https://doclinic-backend.onrender.com/api',
  
  // Google OAuth Client ID (Get from Google Cloud Console)
  // IMPORTANT: Add your production domain to Google OAuth authorized origins
  GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID || '810351956336-u049e1ei4pd4qnqu9h5h4906v7qhd2dn.apps.googleusercontent.com'
};

export default config;
